import { IAgencies, IVendors } from '../business-objects/common';
import * as actionTypes from './actionTypes';

export interface IVendorState {
	allVendors: IVendors[];
	allAgencies: IAgencies[];
	storeUpdated: boolean;
	isProcessing: boolean;
}

export interface IAgencyState {}

const initialState: IVendorState = {
	allVendors: [],
	allAgencies: [],
	storeUpdated: false,
	isProcessing: false
};

export default (state: IVendorState = initialState, action: any) => {
	let _state = { ...state };
	switch (action.type) {
		case actionTypes.SAVE_VENDOR_INFO_TO_STORE:
			_state.allVendors = [ ..._state.allVendors, ...action.value ];
			_state.storeUpdated = true;
			return _state;
		case actionTypes.CREATE_VENDOR:
			_state.allVendors = [ ..._state.allVendors, action.value ];
			_state.storeUpdated = true;
			return _state;
		case actionTypes.UPDATE_VENDOR:
			_state.allVendors = [
				..._state.allVendors.map(
					(vendor) => (vendor.id == action.value.id ? { ...vendor, ...action.value } : vendor)
				)
			];
			if (
				(action.value as IVendors).name != null &&
				_state.allVendors.filter((item) => item.id == (action.value as IVendors).id).length == 0
			)
				_state.allVendors = [ ..._state.allVendors, action.value.vendor ];
			return _state;
		case actionTypes.LOAD_AGENCIES_TO_STORE:
			_state = {
				...state,
				allAgencies: action.value
			};
			return _state;
		case actionTypes.TOGGLE_IS_PROCESSING:
			_state.isProcessing = !_state.isProcessing;
			_state.storeUpdated = !_state.storeUpdated;
			return _state;
		case actionTypes.SAVE_AGENCY_INFO_TO_STORE:
			_state.allAgencies = action.value;
			_state.storeUpdated = true;
			_state.isProcessing = false;
			return _state;
		default:
			return state;
	}
};
